var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgICareStaffArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.067 20.573c0 4.557-3.699 8.25-8.26 8.25-4.556 0-8.249-3.694-8.249-8.25s3.693-8.25 8.249-8.25c4.561-0 8.26 3.694 8.26 8.25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.82 0.524c-3.818 0-9.151 1.522-13.014 5.385l4.588 8.359c1.963-2.491 5.008-4.090 8.426-4.090 3.459 0 6.537 1.634 8.498 4.175l4.5-8.636c-3.343-3.653-9.338-5.192-12.998-5.192zM35.22 6.662h-2.136v2.134h-2.566v-2.134h-2.136v-2.565h2.136v-2.143h2.566v2.143h2.136v2.565z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.966 43.651h2.113l-3.018 10.344h23.581l-3.004-10.344h2.115l3.023 10.344h6.939l-4.736-15.672c-0.74-2.587-3.984-7.142-9.582-7.28l-12.87-0.011c-5.725 0.028-9.037 4.672-9.786 7.29l-4.828 15.672h7.037l3.016-10.343z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.947 57.293h61.73v5.873h-61.73v-5.873z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgICareStaffArea);
export default __webpack_public_path__ + "static/media/i-care-staff-area.f79edd63.svg";
export { ForwardRef as ReactComponent };